<span revTooltip [tooltipContent]="getTooltipText()">
	<i [class]="'fa app-status-icon fa-check-circle ' + getColorClass()"></i>
</span>
